import React, { FC, useEffect, useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import './TransitionWrapper.css';
import { Location, useLocation } from 'react-router-dom';
import { isSettingsRouteGroup, Routes, routesNodeRefs } from './routes';
import { Box } from '@mui/material';

type Props = {
  children?: any;
  transitionOnExit?: () => void;
};

const TransitionWrapper: FC<Props> = ({ children, transitionOnExit }) => {
  const [prevRoute, setPrevRoute] = useState<Routes | null>(null);
  const { pathname } = useLocation() as Location<Routes>;

  useEffect(() => {
    if (prevRoute !== pathname) {
      setPrevRoute(pathname as Routes);
    }
  }, [prevRoute, pathname]);

  const relevantNodeRef = routesNodeRefs[pathname] ?? undefined;
  const relevantKey = isSettingsRouteGroup(prevRoute ?? '', pathname)
    ? Routes.Settings
    : pathname;

  return (
    <Box position="relative">
      <SwitchTransition>
        <CSSTransition
          in
          appear
          timeout={250}
          nodeRef={relevantNodeRef}
          classNames="page"
          key={relevantKey}
          onExited={transitionOnExit}
        >
          <Box
            component="div"
            ref={relevantNodeRef}
            className="page"
            width="100%"
          >
            {children}
          </Box>
        </CSSTransition>
      </SwitchTransition>
    </Box>
  );
};

export default TransitionWrapper;
